// extracted by mini-css-extract-plugin
module.exports = {"nav":"Categories_nav__2NKdJ"};